import { DateTime } from 'luxon';

export const getExpectedQuantity = (orderedQuantity: number, receivedQuantity: number) => {
  return orderedQuantity - receivedQuantity < 0 ? 0 : orderedQuantity - receivedQuantity;
};

export const isToday = (date: string) => {
  const dateTime = DateTime.fromISO(date);
  return dateTime.hasSame(DateTime.now(), 'day');
};
